export default () => {

  // elements
  const els = {
    timeline: document.querySelector('[data-timeline]'),
    timelineItems: document.querySelectorAll('[data-timeline-item]')
  }


  if (els.timeline) {

    const resizeTimeline = () => {
      let totalWidth = 0;
      els.timelineItems.forEach(el => {
        totalWidth += parseInt(window.getComputedStyle(el).marginRight);
        totalWidth += parseInt(window.getComputedStyle(el).marginLeft);
        totalWidth += el.offsetWidth;
      });

      els.timeline.style.width = `${totalWidth}px`;
    };

    window.addEventListener('resize', resizeTimeline);
    resizeTimeline();
  }
};